<template>

  <div class="container">

    <div class="cta-section">

      <h2 class="cta-title">포인트 사용을 먼저 해주세요</h2>
      <p class="cta-subtitle">포인트는 착석한 테이블에서 사용할 수 있습니다.<br/>포인트 사용 후 나머지 금액 결제는 카운터에서 도와드립니다.</p>


      <div
          v-if="tablet_auth"
          style="text-align: center;background-color: white;padding:20px;background-color: #FDFBF7;border-radius:10px;display: flex;justify-content: center;flex-direction: column">
        <div style="color: black;font-size: 1.5em;font-weight: bold;padding-bottom: 20px">
          먼저 스마트폰 카메라로 아래 QR을 촬영해 앱을 다운로드해주세요
        </div>
        <qr-code size="200" :text="'https://b.myshop-order.com/'" style="align-self: center"/>

      </div>
      <div class="cta-buttons"
           v-else
      >
        <button @click="go_apps" class="btn btn-primary">
          {{ $t('install_app') }}
        </button>
      </div>
    </div>

    <!-- Header -->
    <div class="header" style="margin-top: 40px;padding:20px">
      <h1 style="padding-bottom: 15px">1. 주문하신 테이블에 부착된 QR코드를 마이샵포인트 앱에서 스캔해주세요.</h1>

      <p>
        <img class="guideImg1" src="/images/1_1.png" style="width: 90%;max-width: 350px"/>
      </p>
      <p>
        <img class="guideImg1" src="/images/1_2.png" style="width: 90%;max-width: 350px"/>
      </p>
      <p>
        <img class="guideImg1" src="/images/1_3.png" style="width: 90%;max-width: 350px"/>
      </p>
    </div>


    <!-- Header -->
    <div class="header" style="margin-top: 40px;padding:20px">
      <h1 style="padding-bottom: 15px">2. 결제에 사용할 포인트를 입력하시고 계속하기 버튼을 눌러주시면, 보유 포인트가 차감됩니다.</h1>

      <p>
        <img class="guideImg1" src="/images/2_1.png" style="width: 90%;max-width: 350px"/>
      </p>
      <p>
        <img class="guideImg1" src="/images/2_2.png" style="width: 90%;max-width: 350px"/>
      </p>
    </div>


    <!-- Header -->
    <div class="header" style="margin-top: 40px;padding:20px">
      <h1 style="padding-bottom: 15px">3. 사용하신 포인트는 결제 금액에서 차감되며, 나머지 금액을 계산해주세요.</h1>
    </div>

  </div>
</template>
<script>
import {mapGetters} from "vuex";
import VueQRCodeComponent from "vue-qrcode-component";

export default {
  components: {
    'qr-code':VueQRCodeComponent,
  },
	mounted() {
  },
  computed: mapGetters({
    default_font_size: 'default_font_size',
    tablet_auth: 'tablet_auth',
  }),
  methods: {
    close() {
      this.$emit('close')
    },
    go_apps() {
      // Check if the userAgent string contains 'Android'
      const isAndroid = /Android/.test(navigator.userAgent);

      // Check if the userAgent string contains 'iPhone'
      const isiPhone = /iPhone/.test(navigator.userAgent);


      if(this.tablet_auth) {
        // open
        this.emitter.emit("confirm_popup", {
          download_app: true,
        });
        return
      }

      // Example usage
      if (isAndroid) {
        window.open('https://play.google.com/store/apps/details?id=com.mocoplex.myshop.checkout&hl=en_US&pli=1');
      } else if (isiPhone) {
        window.open('https://apps.apple.com/kr/app/%EB%A7%88%EC%9D%B4%EC%83%B5-%EC%B2%B4%ED%81%AC%EC%95%84%EC%9B%83/id1590822341');
      } else {
        // open
        this.emitter.emit("confirm_popup", {
          download_app: true,
        });
        //download_app
      }
    },
  }
}
</script>

<style scoped>

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 1.5em;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 700;
}

.header p {
  font-size: 18px;
  color: #7f8c8d;
  max-width: 600px;
  margin: 0 auto;
}

/* Phone Cards Section */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.platform-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: white;
  margin-right: 15px;
}

.instagram-bg {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.naver-bg {
  background: #03C75A;
}

.google-bg {
  background: #4285F4;
}

.card-title {
  flex: 1;
}

.card-title h3 {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 5px;
}

.rating {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #f39c12;
  font-size: 14px;
}

.phone-preview {
  width: 100%;
  height: 400px;
  background: #f8f9fa;
  border-radius: 15px;
  margin-bottom: 20px;
  padding: 20px;
  border: 2px solid #e9ecef;
}

.preview-item {
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #e9ecef;
}

.preview-image {
  width: 100%;
  height: 100px;
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
  border-radius: 8px;
  margin-bottom: 10px;
}

.preview-text {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.5;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  font-size: 14px;
  color: #495057;
}

.feature-icon {
  width: 20px;
  height: 20px;
  background: #6c757d;
  border-radius: 50%;
}

/* CTA Section */
.cta-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 20px;
  text-align: center;
  color: white;
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
}

.cta-title {
  font-size: 32px;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-subtitle {
  line-height: 1.3;
  font-size: 16px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 15px 35px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  width: 100%;
  background: white;
  color: #667eea;
}

.btn-primary:hover {
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header h1 {

  }

  .platforms-row {
    gap: 30px;
  }

  .platform-logo {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }

  .cta-section {
    padding: 30px 20px;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

/* Subtle animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.6s ease-out;
}

.card:nth-child(1) { animation-delay: 0.1s; }
.card:nth-child(2) { animation-delay: 0.2s; }
.card:nth-child(3) { animation-delay: 0.3s; }
</style>